import { registerBlockType } from '@wordpress/blocks'; 
import { TabPanel, TextControl, ToggleControl, __experimentalBoxControl as BoxControl, BaseControl, RangeControl, 
PanelBody, SelectControl, __experimentalBorderBoxControl as BorderBoxControl, __experimentalUnitControl as UnitControl, Button, ToolbarButton, ToolbarGroup, __experimentalInputControl as InputControl, TextareaControl } from '@wordpress/components';
import { Fragment } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import { useBlockProps, InnerBlocks, RichText, InspectorControls, BlockControls, AlignmentToolbar, PanelColorSettings, FontSizePicker, MediaUpload, MediaUploadCheck } from '@wordpress/block-editor';
import {icons} from './lib/icons';
import FontIconPicker from '@fonticonpicker/react-fonticonpicker';
import {fontfamilylist} from "./lib/fontfamilylist.js";
import { colors } from './lib/colors';

const ServiceBlock = (props) => {

    const { attributes, setAttributes, clientId } = props;  

    const{ bgColor, bghColor, iconFontWeight, iconLineHeight, titlefontSize, titleLineHeight, titleFontWeight, contentfontSize, contentFontWeight, contentLineHeight, iconColor, titleColor, textColor, paddings,margins, iconhColor, titlehColor, texthColor, uniqueid, textAlignment, iconv, fontfamily, iconPadding, titlePadding, textPadding, titleDecoration, titleTransform, titleLetterSpacing, textTransform, textDecoration, textLetterSpacing, iconWidth, hshadow, vshadow, blurshadow, shadowColor, animation, durations, delay, hidedesktop, hidetablet, hidemobile, contentfontfamily, hideDisplay, hideTitle, hideContent, border, borderbottomradius, borderleftradius, borderrightradius, bordertopradius, borderStyle, imageUrl, imgBorder, imgBottomRadius, imgHeight, imgMargin, imgRightRadius, imgleftRadius, imgtopRadius, imgWidth, imghshadow, imgvshadow, imgblurshadow, imgshadowColor, displayType, spreadRadius, addclass, addid, customcss } = attributes;    

    const animationclass='wow animated '+attributes.durations+' '+attributes.animation;

    const displaydesktop=(hidedesktop != true) ? 'hide-desktop' : '';
    const displaytablet=(hidetablet != true)   ? 'hide-tablet' : '';
    const displaymobile=(hidemobile != true)   ? 'hide-mobile' : '';
    const displayclass=displaydesktop+' '+displaytablet+' '+displaymobile;

    const hideCorner =(borderStyle != true) ? 'hide-corner' : '';
    const hideStyle = hideCorner;
    const serviceBox = 'service-box';
    const iconbgimage=(1.5625*iconWidth);
    const serviceImage = plugin.pluginpath + 'assets/images/user2.jpg';
    const serviceValue= ( imageUrl !=null )? imageUrl:serviceImage;
    const onFileSelect=(img)=>{
        props.setAttributes({
            imageUrl:img.url,
            imageID:img.id,
            imageAlt:img.alt,
        })
    }

    const bordertop=(imgBorder.top != undefined) ? `${imgBorder.top.width} ${imgBorder.top.style} ${imgBorder.top.color}` : null;
    const borderright=(imgBorder.right != undefined) ? `${imgBorder.right.width} ${imgBorder.right.style} ${imgBorder.right.color}` : null;
    const borderbottom=(imgBorder.bottom != undefined) ? `${imgBorder.bottom.width} ${imgBorder.bottom.style} ${imgBorder.bottom.color}` : null;
    const borderleft=(imgBorder.left != undefined) ? `${imgBorder.left.width} ${imgBorder.left.style} ${imgBorder.left.color}` : null;


    const blocktop=(border.top != undefined) ? `${border.top.width} ${border.top.style} ${border.top.color}` : null;
    const blockright=(border.right != undefined) ? `${border.right.width} ${border.right.style} ${border.right.color}` : null;
    const blockbottom=(border.bottom != undefined) ? `${border.bottom.width} ${border.bottom.style} ${border.bottom.color}` : null;
    const blockleft=(border.left != undefined) ? `${border.left.width} ${border.left.style} ${border.left.color}` : null;
        
    function setbgColor(value){
        setAttributes({bgColor :value})
    }
    function setbghColor(value) {
        setAttributes({bghColor:value});
    }
    function seticonColor(value){
        setAttributes({iconColor :value})
    }
    function seticonhColor(value) {
        setAttributes({iconhColor:value});
    }
    function settitleColor(value){
        setAttributes({titleColor :value})
    }
    function settitlehColor(value) {
        setAttributes({titlehColor:value});
    }
    function settexthColor(value) {
        setAttributes({texthColor:value});
    }
    function settextColor(value){
        setAttributes({textColor :value})
    }   
    function setShadowColor(value) {
        setAttributes({shadowColor:value});
    }
    function setImgShadowColor(value) {
        setAttributes({imgshadowColor:value});
    }
    
    setAttributes({ uniqueid: 'service-id' +clientId.slice(0,8) });
    const alignmentClass = (attributes.textAlignment != null) ? 'has-text-align-' + attributes.textAlignment : 'has-text-align-center';
    const blockProps = useBlockProps();

    const ColorPanel = () => (
        <TabPanel
            className={"color-tab-panel"}
            activeClass={"active-tab"}
            tabs={[
                {
                    name: __('normal', 'spice-blocks'),
                    title: __('Normal', 'spice-blocks'),
                    className: 'tab-one',
                    content:<PanelColorSettings  initialOpen={open}
                        
                        colorSettings={[
                            {
                                value: bgColor,
                                enableAlpha:true,
                                default:'#f5f5f5',
                                onChange: setbgColor,
                                clearable: true,
                                label: __('Background','spice-blocks')
                            },
                            {   
                                value: iconColor,
                                enableAlpha:true,
                                onChange: seticonColor,
                                clearable: true,
                                label: __('Icon','spice-blocks'),
                                
                            },
                            {
                                value: titleColor,
                                enableAlpha:true,
                                onChange: settitleColor,
                                clearable: true,
                                label: __('Title','spice-blocks')
                            },
                            {
                                value: textColor,
                                enableAlpha:true,
                                onChange: settextColor,
                                clearable: true,
                                label: __('Content','spice-blocks')
                            },
                        ]}
                        className={'spice-blocks-normal-button'}
                    />
                },
                {
                    name: __('hover', 'spice-blocks'),
                    title: __('Hover', 'spice-blocks'),
                    className: 'tab-two',
                    content:<PanelColorSettings  initialOpen={open}
                        
                        colorSettings={[
                            {   
                                value: bghColor,
                                enableAlpha:true,
                                onChange: setbghColor,
                                clearable: true,
                                label: __('Background','spice-blocks'),
                                
                            },
                            {   
                                value: iconhColor,
                                enableAlpha:true,
                                onChange: seticonhColor,
                                clearable: true,
                                label: __('Icon','spice-blocks'),
                                
                            },
                            {   
                                value: titlehColor,
                                enableAlpha:true,
                                onChange: settitlehColor,
                                clearable: true,
                                label: __('Title','spice-blocks'),
                                
                            },
                            {   
                                value: texthColor,
                                enableAlpha:true,
                                onChange: settexthColor,
                                clearable: true,
                                label: __('Content','spice-blocks'),
                                
                            },
                        ]}
                        className={'spice-blocks-hover-button'}
                    />
                },
            ]}
        >
        { ( tab ) => <p>{ tab.content }</p> }
        </TabPanel>
    );

    if(fontfamily !=null){
        let url = 'https://fonts.googleapis.com/css2?family='+fontfamily+':wght@100;200;300;400;500;600;700;800;900&display=swap';
         let link = document.createElement('link')
          link.href = url;
          link.rel = "stylesheet";
          link.type =  "text/css";
          
          if ( jQuery("body").hasClass("site-editor-php") ) { 
          jQuery('iframe').contents().find("head").append(link);
      }
      else{
        document.head.appendChild(link);
      }
    }   

    if(contentfontfamily !=null){
        let url = 'https://fonts.googleapis.com/css2?family='+contentfontfamily+':wght@100;200;300;400;500;600;700;800;900&display=swap';
         let link = document.createElement('link')
          link.href = url;
          link.rel = "stylesheet";
          link.type =  "text/css";
          
          if ( jQuery("body").hasClass("site-editor-php") ) { 
          jQuery('iframe').contents().find("head").append(link);
      }
      else{
        document.head.appendChild(link);
      }
    }   

    return (
        <Fragment>
            <style dangerouslySetInnerHTML={{
                  __html: [
                     `.service-box#${uniqueid}{
                        background-color : ${bgColor};
                        margin: ${margins.top} ${margins.right} ${margins.bottom} ${margins.left};
                        padding: ${paddings.top} ${paddings.right} ${paddings.bottom} ${paddings.left};
                        box-shadow: ${hshadow}px ${vshadow}px ${blurshadow}px ${shadowColor};
                        border: ${border.width} ${border.style} ${border.color};
                        border-top:${blocktop};
                        border-right:${blockright};
                        border-bottom:${blockbottom};
                        border-left:${blockleft};
                        border-radius: ${bordertopradius} ${borderrightradius} ${borderbottomradius} ${borderleftradius};
                     }
                     .hide-corner#${uniqueid}:before{
                        display: none;
                     }
                     .hide-corner#${uniqueid}:after{
                        display: none;
                     }
                     .service-box#${uniqueid}:before{
                        border-left: 2px solid ${bghColor};
                        border-top: 2px solid ${bghColor};
                     }
                     .service-box#${uniqueid}:after{
                        border-right: 2px solid ${bghColor};
                        border-bottom: 2px solid ${bghColor};
                     }
                     .service-box#${uniqueid} .icon:before{
                        width:${iconbgimage}px;
                        height:${iconbgimage}px;
                     }
                     .service-box#${uniqueid} .icon i{
                        color: ${iconColor}; 
                        font-size: ${iconWidth + 'px'};
                        font-weight: ${iconFontWeight};
                        line-height: ${iconLineHeight}px;
                        padding: ${iconPadding.top} ${iconPadding.right} ${iconPadding.bottom} ${iconPadding.left};
                     }
                     .service-box#${uniqueid} .col-text h4{
                        color: ${titleColor};
                        font-size: ${titlefontSize};
                        font-weight: ${titleFontWeight};
                        font-family: ${fontfamily};
                        padding: ${titlePadding.top} ${titlePadding.right} ${titlePadding.bottom} ${titlePadding.left};
                        text-transform: ${titleTransform};
                        text-decoration: ${titleDecoration};                   
                        line-height: ${titleLineHeight}px;
                        letter-spacing: ${titleLetterSpacing + 'px'};
                     }
                     .service-box#${uniqueid} .col-text p{
                        color: ${textColor};
                        font-size: ${contentfontSize};
                        font-weight: ${contentFontWeight};
                        font-family: ${contentfontfamily};
                        padding: ${textPadding.top} ${textPadding.right} ${textPadding.bottom} ${textPadding.left};
                        text-transform: ${textTransform};
                        text-decoration: ${textDecoration};
                        line-height: ${contentLineHeight}px;
                        letter-spacing: ${textLetterSpacing + 'px'};
                     }
                     .service-box#${uniqueid}:hover{
                        background-color: ${bghColor};                    
                        }
                     .service-box#${uniqueid}:hover .icon i{
                        color: ${iconhColor};
                        }
                     .service-box#${uniqueid}:hover .col-text h4{
                        color: ${titlehColor};
                        }
                     .service-box#${uniqueid}:hover .col-text p{
                        color: ${texthColor};
                        }
                      .service-box#${uniqueid} .service-box-avatar{
                         margin: ${imgMargin.top} ${imgMargin.right ? imgMargin.right: 'auto'} ${imgMargin.bottom} ${imgMargin.left ? imgMargin.left: 'auto'};
                        width: ${imgWidth + 'px'};
                        height: auto;
                      }
                      .service-box#${uniqueid} .service-box-avatar img{
                        border: ${imgBorder.width} ${imgBorder.style} ${imgBorder.color};
                        border-top:${bordertop};
                        border-right:${borderright};
                        border-bottom:${borderbottom};
                        border-left:${borderleft};
                        border-radius: ${imgtopRadius} ${imgRightRadius} ${imgBottomRadius} ${imgleftRadius};
                        box-shadow: ${imgshadowColor} ${imghshadow}px ${imgvshadow}px ${imgblurshadow}px ${spreadRadius}px ;
                      }
                    .${uniqueid}.has-text-align-right .service-box#${uniqueid}  figure.service-box-avatar{margin-right: 0;}
                    .${uniqueid}.has-text-align-left .service-box#${uniqueid} figure.service-box-avatar{margin-left: 0;}
                    .${uniqueid}.has-text-align-right figure.service-box-avatar{margin-right: 0;}
                    .${uniqueid}.has-text-align-left figure.service-box-avatar{margin-left: 0;}
                    ${customcss}`           
                    ].join('\n')
                  }}>
            </style>
            <InspectorControls>
                <PanelBody initialOpen={false} title={__('General Settings','spice-blocks')}>
                    <ToggleControl 
                        label={__('Enable/Disable Icon/Image','spice-blocks')}
                        checked={hideDisplay}
                        onChange={(newval) => setAttributes({ hideDisplay: newval })}
                    />
                    {hideDisplay && (
                        <Fragment>
                            <SelectControl 
                                label={__('Select Type','spice-blocks')}
                                value={ displayType }
                                options={ [
                                    { label: __('Icon','spice-blocks'), value: 'icon' },
                                    { label: __('Image','spice-blocks'), value: 'image' },
                                ] }
                                onChange={ (setIconWeight) =>
                                    setAttributes({displayType:setIconWeight}) }
                            />
                            

                            {displayType == 'icon' && (
                                <PanelBody initialOpen={false} title={__('Icon Settings','spice-blocks')} className={'spice-panel-edit'}>
                                    <FontIconPicker
                                        theme={"default spicegsicon "+uniqueid}                                                                     
                                        icons={icons}
                                        value={iconv}
                                        onChange={(val) => setAttributes({ iconv: val })}
                                    /> 
                                    <RangeControl 
                                            label={__('Width(px)','spice-blocks')}
                                            value={iconWidth}
                                            onChange={(newtext) => setAttributes({ iconWidth: newtext })}
                                            min={0}
                                            step={1}
                                            max={100}

                                    />
                                    <BoxControl 
                                            label={__('Icon Padding','spice-blocks')}
                                            values={iconPadding}
                                            allowReset={false}
                                            units={[]}
                                            onChange={(userVal) => setAttributes({
                                                iconPadding:{
                                                    top:userVal.top,
                                                    right:userVal.right,
                                                    bottom:userVal.bottom,
                                                    left:userVal.left
                                                }
                                            })}
                                    />
                                </PanelBody>
                            )}

                            {displayType == 'image' && (
                                <PanelBody initialOpen={false} title={__('Image Settings','spice-blocks')} className={'spice-panel-edit'}>
                                    <RangeControl 
                                        label={ __('Image Dimension(px)','spice-blocks') }                
                                        value={ {imgWidth, imgHeight}}
                                        onChange={(newtext) => setAttributes({ imgWidth: newtext, imgHeight: newtext })}
                                        min={0}
                                        max={500}
                                    />
                                    <BorderBoxControl
                                        colors={colors}
                                        enableAlpha={'true'}
                                        label={ __( 'Image Border' ,'spice-blocks') }
                                        onChange={(newtext) => setAttributes({ imgBorder: newtext })}
                                        value={ imgBorder }
                                    />  
                                    <BaseControl className="spice-blocks-border-radius" label={__('Image Border Radius','spice-blocks')} __nextHasNoMarginBottom={ true }>
                                        <UnitControl className={"border-radius-top"} onChange={ (newtext) => setAttributes({ imgtopRadius: newtext }) } value={ imgtopRadius } placeholder={"Top"} />

                                        <UnitControl className={"border-radius-right"} onChange={ (newtext) => setAttributes({ imgRightRadius: newtext }) } value={ imgRightRadius } placeholder={"right"} />

                                        <UnitControl className={"border-radius-left"} onChange={ (newtext) => setAttributes({ imgleftRadius: newtext }) } value={ imgleftRadius } placeholder={"left"}/>

                                        <UnitControl className={"border-radius-bottom"}  onChange={ (newtext) => setAttributes({ imgBottomRadius: newtext }) } value={ imgBottomRadius }  placeholder={"bottom"}/>  
                                    </BaseControl>  
                                    <BoxControl 
                                        label={__('Image Margin','spice-blocks')}
                                        values={imgMargin}
                                        sides={['top', 'bottom','left','right']}
                                        allowReset={false}
                                        units={[]}
                                        onChange={(newValue) =>
                                        setAttributes({
                                                ...imgMargin,
                                                imgMargin: {
                                                    top: newValue.top,
                                                    left: newValue.left,
                                                    right: newValue.right,
                                                    bottom: newValue.bottom,
                                                },
                                            })
                                        }
                                    />   
                                </PanelBody>
                            )}
                        </Fragment>
                    )}

                    <PanelBody initialOpen={false} title={__('Box Settings','spice-blocks') } className={"spice-panel-edit"} >
                        <ToggleControl
                            label={__('Enable/Disable Border Style','spice-blocks')}
                            checked={borderStyle}
                            onChange={(newval) => setAttributes({ borderStyle: newval })}
                        />
                        <BorderBoxControl
                            colors={colors}
                            enableAlpha={'true'}
                            label={ __( 'Box Border' ,'spice-blocks') }
                            value={ border }
                            onChange={(newtext) => setAttributes({ border: newtext })}
                        />
                        <BaseControl className="spice-blocks-border-radius" label={__('Box Border Radius','spice-blocks')} __nextHasNoMarginBottom={ true }>
                            <UnitControl className={"border-radius-top"} onChange={ (newtext) => setAttributes({ bordertopradius: newtext }) } value={ bordertopradius } placeholder={"Top"} />

                            <UnitControl className={"border-radius-right"} onChange={ (newtext) => setAttributes({ borderrightradius: newtext }) } value={ borderrightradius } placeholder={"right"} 
                            />                  
                            
                            <UnitControl className={"border-radius-left"} onChange={ (newtext) => setAttributes({ borderleftradius: newtext }) } value={ borderleftradius } placeholder={"left"}/>

                            <UnitControl className={"border-radius-bottom"}  onChange={ (newtext) => setAttributes({ borderbottomradius: newtext }) } value={ borderbottomradius }  placeholder={"bottom"}
                            />         
                        </BaseControl>
                        <BoxControl 
                            label={__('Box Margin','spice-blocks')}
                            values={margins}
                            sides={['top', 'bottom','left','right']}
                            allowReset={false}
                            units={[]}
                            onChange={(newValue) =>
                                setAttributes({
                                    ...margins,
                                    margins: {
                                        top: newValue.top,
                                        right: newValue.right,
                                        bottom: newValue.bottom,
                                        left: newValue.left,
                                    },
                                })
                            }
                        />
                        <BoxControl 
                            label={__('Box Padding','spice-blocks')}
                            values={paddings}
                            allowReset={false}
                            units={[]}
                            onChange={(userVal) => setAttributes({
                                                        paddings:{
                                                            top:userVal.top,
                                                            right:userVal.right,
                                                            bottom:userVal.bottom,
                                                            left:userVal.left
                                                        }
                                                    })
                            }
                        />
                    </PanelBody>
                        
                    <PanelBody initialOpen={false} title={__('Title Settings','spice-blocks')} className={'spice-panel-edit'}>
                        <ToggleControl
                            label={__('Enable/Disable Title','spice-blocks')}
                            checked={hideTitle}
                            onChange={(newval) => setAttributes({ hideTitle: newval })}
                        />
                        {hideTitle && (
                            <BoxControl 
                                label={__('Title Padding','spice-blocks')}
                                values={titlePadding}
                                allowReset={false}
                                units={[]}
                                onChange={(userVal) =>setAttributes({
                                                            titlePadding:{
                                                                top:userVal.top,
                                                                right:userVal.right,
                                                                bottom:userVal.bottom,
                                                                left:userVal.left
                                                            }
                                                        })
                                        }
                            />
                        )}
                    </PanelBody>    
                        
                    <PanelBody initialOpen={false} title={__('Content Settings','spice-blocks')} className={'spice-panel-edit'}>
                        <ToggleControl
                            label={__('Enable/Disable Content','spice-blocks')}
                            checked={hideContent}
                            onChange={(newval) => setAttributes({ hideContent: newval })}
                        /> 
                        {hideContent && (
                            <BoxControl 
                                    label={__('Content Padding','spice-blocks')}
                                    values={textPadding}
                                    allowReset={false}
                                    units={[]}
                                    onChange={(userVal) => setAttributes({
                                        textPadding:{
                                            top:userVal.top,
                                            right:userVal.right,
                                            bottom:userVal.bottom,
                                            left:userVal.left
                                        }
                                    })}
                            />  
                        )}     
                    </PanelBody>   

                    <PanelBody initialOpen={false} title={__('Display','spice-blocks') } className={'spice-panel-edit'}>     
                        <ToggleControl
                            label={__('Enable/Disable on Desktop','spice-blocks')}
                            checked={hidedesktop}
                            onChange={(newval) => setAttributes({ hidedesktop: newval })}
                        />
                        <ToggleControl
                            label={__('Enable/Disable on Tablet','spice-blocks')}
                            checked={hidetablet}
                            onChange={(newval) => setAttributes({ hidetablet: newval })}
                        />
                        <ToggleControl
                            label={__('Enable/Disable on Mobile','spice-blocks')}
                            checked={hidemobile}
                            onChange={(newval) => setAttributes({ hidemobile: newval })}
                        />
                    </PanelBody>                

                    <PanelBody initialOpen={false} title={__('Animation Effects','spice-blocks')} className={'spice-panel-edit'}>
                        <SelectControl
                            label={__('Animation','spice-blocks')}
                            value={ animation }
                            options={ [
                                { label: __('None','spice-blocks'), value: '' },
                                { label: __('Bounce','spice-blocks'), value: 'bounce' },
                                { label: __('Flash','spice-blocks'), value: 'flash' },
                                { label: __('Pulse','spice-blocks'), value: 'pulse' },
                                { label: __('RubberBand','spice-blocks'), value: 'rubberBand' },
                                { label: __('Shake','spice-blocks'), value: 'shake' },
                                { label: __('Swing','spice-blocks'), value: 'swing' },
                                { label: __('Tada','spice-blocks'), value: 'tada' },
                                { label: __('Wobble','spice-blocks'), value: 'wobble' },
                                { label: __('Jello','spice-blocks'), value: 'jello' },
                                { label: __('BounceIn','spice-blocks'), value: 'bounceIn' },
                                { label: __('BounceInDown','spice-blocks'), value: 'bounceInDown' },
                                { label: __('BounceInLeft','spice-blocks'), value: 'bounceInLeft' },
                                { label: __('BounceInRight','spice-blocks'), value: 'bounceInRight' },
                                { label: __('BounceInUp','spice-blocks'), value: 'bounceInUp' },
                                { label: __('FadeIn','spice-blocks'), value: 'fadeIn' },
                                { label: __('FadeInDown','spice-blocks'), value: 'fadeInDown' },
                                { label: __('FadeInDownBig','spice-blocks'), value: 'fadeInDownBig' },
                                { label: __('FadeInLeft','spice-blocks'), value: 'fadeInLeft' },
                                { label: __('FadeInLeftBig','spice-blocks'), value: 'fadeInLeftBig' },
                                { label: __('FadeInRight','spice-blocks'), value: 'fadeInRight' },
                                { label: __('FadeInRightBig','spice-blocks'), value: 'fadeInRightBig' },
                                { label: __('FadeInUp','spice-blocks'), value: 'fadeInUp' },
                                { label: __('FadeInUpBig','spice-blocks'), value: 'fadeInUpBig' },
                                { label: __('Flip','spice-blocks'), value: 'flip' },
                                { label: __('FlipInX','spice-blocks'), value: 'flipInX' },
                                { label: __('FlipInY','spice-blocks'), value: 'flipInY' },
                                { label: __('LightSpeedIn','spice-blocks'), value: 'lightSpeedIn' },
                                { label: __('RollIn','spice-blocks'), value: 'rollIn' },
                                { label: __('RotateIn','spice-blocks'), value: 'rotateIn' },
                                { label: __('RotateInDownLeft','spice-blocks'), value: 'rotateInDownLeft' },
                                { label: __('RotateInDownRight','spice-blocks'), value: 'rotateInDownRight' },
                                { label: __('RotateInUpLeft','spice-blocks'), value: 'rotateInUpLeft' },
                                { label: __('RotateInUpRight','spice-blocks'), value: 'rotateInUpRight' },
                                { label: __('SlideInDown','spice-blocks'), value: 'slideInDown' },
                                { label: __('SlideInLeft','spice-blocks'), value: 'slideInLeft' },
                                { label: __('SlideInRight','spice-blocks'), value: 'slideInRight' },
                                { label: __('ZoomIn','spice-blocks'), value: 'zoomIn' },
                                { label: __('ZoomInDown','spice-blocks'), value: 'zoomInDown' },
                                { label: __('ZoomInLeft','spice-blocks'), value: 'zoomInLeft' },
                                { label: __('ZoomInRight','spice-blocks'), value: 'zoomInRight' },
                                { label: __('ZoomInUp','spice-blocks'), value: 'zoomInUp' },
                            ] }
                            onChange={ (newtext) => setAttributes({ animation: newtext }) }                   
                        />  
                        { animation != ''  && (
                            <>
                                <SelectControl
                                    label={__('Durations','spice-blocks')}
                                    value={ durations }
                                    options={ [
                                        { label: __('Normal','spice-blocks'), value: ' ' },
                                        { label: __('Slow','spice-blocks'), value: 'slow' },
                                        { label: __('Fast','spice-blocks'), value: 'fast' },
                                    ] }
                                    onChange={ (newtext) => setAttributes({ durations: newtext }) }                   
                                />  
                                <TextControl
                                    label={__('Delay(ms)','spice-blocks')}              
                                    value={delay}
                                    onChange={(newtext) => setAttributes({ delay: newtext })}
                                />
                            </>
                        )}
                    </PanelBody>

                </PanelBody> 

                <PanelBody initialOpen={false} title={ __('Box Shadow','spice-blocks') }>   
                    <RangeControl 
                        label={ __('Horizontal Shadow(px)','spice-blocks') }                
                        value={ hshadow}
                        onChange={(newtext) => setAttributes({ hshadow: newtext })}
                        min={0}
                        max={100}
                    />
                    <RangeControl 
                        label={ __('Vertical Shadow(px)','spice-blocks') }              
                        value={ vshadow}
                        onChange={(newtext) => setAttributes({ vshadow: newtext })}
                        min={0}
                        max={100}
                    />  
                    <RangeControl 
                        label={ __('Blur Shadow(px)','spice-blocks') }              
                        value={ blurshadow}
                        onChange={(newtext) => setAttributes({ blurshadow: newtext })}
                        min={0}
                        max={100}
                    />
                    <PanelColorSettings  initialOpen={true}
                        className='spice-block-section-bg-color'
                        title={ __('Box Shadow Color','spice-blocks') }
                        colorSettings={[
                            {
                            value: shadowColor,
                            enableAlpha:true,
                            onChange: setShadowColor,
                            clearable:true,
                            label: __('Box Shadow','spice-blocks')
                            },
                        ]}
                    />
                </PanelBody> 

                {hideDisplay && (
                    <Fragment>
                        {displayType == 'image' && (
                            <PanelBody initialOpen={false} title={ __('Image Box Shadow','spice-blocks') }>   
                                <RangeControl 
                                    label={ __('Horizontal Shadow(px)','spice-blocks') }                
                                    value={ imghshadow}
                                    onChange={(newtext) => setAttributes({ imghshadow: newtext })}
                                    min={0}
                                    max={100}
                                />
                                <RangeControl 
                                    label={ __('Vertical Shadow(px)','spice-blocks') }              
                                    value={ imgvshadow}
                                    onChange={(newtext) => setAttributes({ imgvshadow: newtext })}
                                    min={0}
                                    max={100}
                                />  
                                <RangeControl 
                                    label={ __('Blur Shadow(px)','spice-blocks') }              
                                    value={ imgblurshadow}
                                    onChange={(newtext) => setAttributes({ imgblurshadow: newtext })}
                                    min={0}
                                    max={100}
                                />
                                <RangeControl 
                                    label={ __('Spread Radius(px)','spice-blocks') }              
                                    value={ spreadRadius}
                                    onChange={(newtext) => setAttributes({ spreadRadius: newtext })}
                                    min={0}
                                    max={100}
                                />
                                <PanelColorSettings  initialOpen={true}
                                    className='spice-block-section-bg-color'
                                    title={ __('Box Shadow Color','spice-blocks') }
                                    colorSettings={[
                                        {
                                        value: imgshadowColor,
                                        enableAlpha:true,
                                        onChange: setImgShadowColor,
                                        clearable:true,
                                        label: __('Box Shadow','spice-blocks')
                                        },
                                    ]}
                                />
                            </PanelBody>  
                        )} 
                    </Fragment>
                )}            

                <PanelBody initialOpen={false} title={__('Color & Background Settings','spice-blocks')} className={"spice-blocks-dual-color"} >
                    <div {...blockProps} >{ColorPanel()}</div>                 
                </PanelBody>

                <PanelBody initialOpen={false} title={__('Typography Settings','spice-blocks')}>                
                   {hideDisplay && (
                        <Fragment>
                            {displayType == 'icon' && (
                                <PanelBody initialOpen={false} title={__('Icon Font Typography','spice-blocks')}>
                                    <SelectControl
                                        label={__('Font Weight','spice-blocks')}
                                        value={ iconFontWeight }
                                        options={ [
                                            { label: __('Light','spice-blocks'), value: '300' },
                                            { label: __('Bold','spice-blocks'), value: '700' },
                                        ] }
                                        onChange={ (setIconWeight) =>
                                            setAttributes({iconFontWeight:setIconWeight}) }
                                    />
                                    <RangeControl 
                                        label={__('Line Height(px)','spice-blocks')}
                                        value={ iconLineHeight}
                                        onChange={(newtext) => setAttributes({ iconLineHeight: newtext })}
                                        min={0}
                                        max={100}
                                    />         
                                </PanelBody>
                            )}
                        </Fragment>
                    )}

                    <PanelBody initialOpen={false} title={__('Title Font Typography','spice-blocks')}>                         
                        <SelectControl
                            label={__(' Font Family','spice-blocks')}
                            value={ fontfamily }
                            options={fontfamilylist}
                            onChange={ (newtext) => setAttributes({ fontfamily: newtext }) }
                        />
                        <FontSizePicker 
                            value={ titlefontSize }
                            onChange={(userVal) => setAttributes({
                                        titlefontSize: userVal
                                    })}
                            __nextHasNoMarginBottom
                        />
                        <SelectControl
                            label={__('Font Weight','spice-blocks')}
                            value={ titleFontWeight }
                            options={ [
                                { label: __('Thin','spice-blocks'), value: '100' },
                                { label: __('Extra Light','spice-blocks'), value: '200' },
                                { label: __('Light','spice-blocks'), value: '300' },
                                { label: __('Regular','spice-blocks'), value: '400' },
                                { label: __('Medium','spice-blocks'), value: '500' },
                                { label: __('Semi Bold','spice-blocks'), value: '600' },
                                { label: __('Bold','spice-blocks'), value: '700' },
                                { label: __('Extra Bold','spice-blocks'), value: '800' },
                                { label: __('Black','spice-blocks'), value: '900' },
                            ] }
                            onChange={ (setTitleWeight) =>
                            setAttributes({titleFontWeight:setTitleWeight}) }
                        />
                        <RangeControl 
                            label={__('Line Height(px)','spice-blocks')}                
                            value={ titleLineHeight}
                            onChange={(newtext) => setAttributes({ titleLineHeight: newtext })}
                            min={0}
                            max={100}
                        />
                        <SelectControl
                            label={__('Transform','spice-blocks')}
                            value={ titleTransform }
                            options={ [
                                { label: __('Default','spice-blocks'), value: '' },
                                { label: __('Uppercase','spice-blocks'), value: 'uppercase' },
                                { label: __('Lowercase','spice-blocks'), value: 'lowercase' },
                                { label: __('Capitalize','spice-blocks'), value: 'capitalize' },
                            ] }
                            onChange={ (newtext) => setAttributes({ titleTransform: newtext }) }                      
                        />
                        <SelectControl
                            label={__('Decoration ','spice-blocks')}
                            value={ titleDecoration }
                            options={ [
                                { label: __('Default','spice-blocks'), value: '' },
                                { label: __('Underline','spice-blocks'), value: 'underline' },
                                { label: __('Overline','spice-blocks'), value: 'overline' },
                                { label: __('Line Through','spice-blocks'), value: 'line-through' },
                            ] }
                            onChange={ (newtext) => setAttributes({ titleDecoration: newtext }) }                     
                        />
                        <RangeControl 
                            label={__('Letter Spacing','spice-blocks')}             
                            value={ titleLetterSpacing}
                            onChange={(newtext) => setAttributes({ titleLetterSpacing: newtext })}
                            min={-10}
                            step={0.1}
                            max={10}
                        />
                    </PanelBody>

                    <PanelBody initialOpen={false} title={__('Content Font Typography','spice-blocks')}>                     
                        <SelectControl
                            label={__(' Font Family','spice-blocks')}
                            value={ contentfontfamily }
                            options={fontfamilylist}
                            onChange={ (newtext) => setAttributes({ contentfontfamily: newtext }) }
                        />
                        <FontSizePicker 
                            value={ contentfontSize }
                            onChange={(userVal) => setAttributes({
                                        contentfontSize: userVal
                                    })}
                            __nextHasNoMarginBottom
                        />
                        <SelectControl
                            label={__('Font Weight','spice-blocks')}
                            value={ contentFontWeight }
                            options={ [
                                { label: __('Thin','spice-blocks'), value: '100' },
                                { label: __('Extra Light','spice-blocks'), value: '200' },
                                { label: __('Light','spice-blocks'), value: '300' },
                                { label: __('Regular','spice-blocks'), value: '400' },
                                { label: __('Medium','spice-blocks'), value: '500' },
                                { label: __('Semi Bold','spice-blocks'), value: '600' },
                                { label: __('Bold','spice-blocks'), value: '700' },
                                { label: __('Extra Bold','spice-blocks'), value: '800' },
                                { label: __('Black','spice-blocks'), value: '900' },
                            ] }
                            onChange={ (setContentWeight) =>
                                setAttributes({contentFontWeight:setContentWeight}) }
                        />
                        <RangeControl 
                            label={__('Line Height(px)','spice-blocks')}            
                            value={ contentLineHeight}
                            onChange={(newtext) => setAttributes({ contentLineHeight: newtext })}
                            min={0}
                            max={100}
                        />
                        <SelectControl
                            label={__('Transform','spice-blocks')}
                            value={ textTransform }
                            options={ [
                                { label: __('Default','spice-blocks'), value: '' },
                                { label: __('Uppercase','spice-blocks'), value: 'uppercase' },
                                { label: __('Lowercase','spice-blocks'), value: 'lowercase' },
                                { label: __('Capitalize','spice-blocks'), value: 'capitalize' },
                            ] }
                            onChange={ (newtext) => setAttributes({ textTransform: newtext }) }                   
                        />
                        <SelectControl
                            label={__('Decoration ','spice-blocks')}
                            value={ textDecoration }
                            options={ [
                                { label: __('Default','spice-blocks'), value: '' },
                                { label: __('Underline','spice-blocks'), value: 'underline' },
                                { label: __('Overline','spice-blocks'), value: 'overline' },
                                { label: __('Line Through','spice-blocks'), value: 'line-through' },
                            ] }
                            onChange={ (newtext) => setAttributes({ textDecoration: newtext }) }                      
                        />
                        <RangeControl 
                            label={__('Letter Spacing','spice-blocks')}             
                            value={ textLetterSpacing}
                            onChange={(newtext) => setAttributes({ textLetterSpacing: newtext })}
                            min={-10}
                            step={0.1}
                            max={10}
                        />
                    </PanelBody>

                </PanelBody>
                <PanelBody initialOpen={false} title={__('Additional Settings','spice-blocks')}>
                    <InputControl
                        label={__('Additional ID','spice-blocks')}
                        value={ addid }
                        onChange={ (userVal)=> setAttributes({addid:userVal}) }
                    />
                    <InputControl
                        label={__('Additional Class','spice-blocks')}
                        value={ addclass }
                        onChange={ (userVal)=> setAttributes({addclass:userVal}) }
                    />
                    <TextareaControl
                        label={__('Custom CSS','spice-blocks')}
                        value={ customcss }
                        onChange={ (userVal)=> setAttributes({customcss:userVal}) }
                    />
                </PanelBody>    
            </InspectorControls>

            <BlockControls>
                <AlignmentToolbar
                    value={attributes.textAlignment}
                    onChange={(newalign) => setAttributes({ textAlignment: newalign })}
                />
            </BlockControls>
            {(props.attributes.imageUrl)? (
                <div className={`${animationclass} ${displayclass} ${alignmentClass} ${uniqueid} ${addclass}`} style={{ 
                    animationDelay: delay+ 'ms'}} id={`${addid}`}>
                    <div className={`${serviceBox} ${hideStyle}`} id={uniqueid} >
                        {hideDisplay && (
                            <Fragment>
                                {displayType == 'icon'  && (
                                    <div className='icon'>
                                        <i className={iconv}></i>
                                    </div>
                                )}  

                                {displayType == 'image' &&  (
                                    <figure className='service-box-avatar'>
                                        <img src={serviceValue} alt={props.attributes.imageAlt} />
                                        {(props.isSelected) ? (
                                            <BlockControls>
                                                <ToolbarGroup>
                                                    <MediaUploadCheck>
                                                        <MediaUpload
                                                            addToGallery={true}
                                                            onSelect={onFileSelect}
                                                            allowedTypes={["image"]}
                                                            value={props.attributes.imageID}
                                                            render={({ open }) => (
                                                                <ToolbarButton onClick={open}>
                                                                    {__("Replace Image", "spice-block")}
                                                                </ToolbarButton>)}
                                                        />
                                                    </MediaUploadCheck>
                                                </ToolbarGroup>
                                            </BlockControls>
                                        ) : null 
                                        }
                                    </figure>  
                                )}    
                            </Fragment>
                        )}
                            
                        <div className={"col-text"}>
                            {hideTitle && (
                                <RichText 
                                    tagName="h4"
                                    placeholder="Write your heading here"
                                    value={attributes.heading}
                                    onChange={(newtext) => setAttributes({ heading: newtext })}
                                />
                            )}
                            {hideContent &&(
                                <RichText
                                    tagName="p"     
                                    placeholder="Write your paragraph here"
                                    value={attributes.text}
                                    onChange={(newtext) => setAttributes({ text: newtext })}
                                />
                            )}
                        </div>
                        <InnerBlocks 
                            template={[
                                ['spice-blocks/spice-button', {
                                    title : 'Read More',
                                    titleColor : '#ffffff',
                                    bgColor : '#2c7bfe',
                                    border: {
                                        color: '#ffffff',
                                        style: 'solid',
                                        width: '1px', 
                                    },
                                    bordertopradius : 30 + 'px',
                                    borderrightradius : 30 + 'px',
                                    borderbottomradius : 30 + 'px',
                                    borderleftradius : 30 + 'px',
                                    titlefontSize : 16 + 'px',
                                    TitleLineHeight : 26 ,
                                    fontfamily : 'Mulish',
                                    textAlignment : 'center',
                                }]
                            ]}
                        allowedBlocks={ false } />
                    </div>
                </div>
            ):(
                <MediaUpload 
                    onSelect={onFileSelect}
                    allowedTypes={ ["image"] }
                    value={props.attributes.imageID}
                    render={({open})=>
                        <Button className="spice-image-button" type="image" style={{height: 'auto', width:'auto'}}>
                            <div className={`${animationclass} ${displayclass} ${alignmentClass} ${addclass}`} style={{ 
                                animationDelay: delay+ 'ms'}} id={`${addid}`}>
                                <div className={`${serviceBox} ${hideStyle}`} id={uniqueid} >
                                    {hideDisplay && (
                                        <Fragment>
                                            {displayType == 'icon' && (
                                                <div className='icon'>
                                                    <i className={iconv}></i>
                                                </div>
                                            )}  
                                            {displayType == 'image' && (
                                                <figure className='service-box-avatar' onClick={open}>
                                                    <img src={serviceImage} />
                                                </figure> 
                                            )}     
                                        </Fragment>
                                    )}
                                    
                                    <div className={"col-text"}>
                                        {hideTitle && (
                                            <RichText 
                                                tagName="h4"
                                                placeholder="Write your heading here"
                                                value={attributes.heading}
                                                onChange={(newtext) => setAttributes({ heading: newtext })}
                                            />
                                        )}
                                        {hideContent &&(
                                            <RichText
                                                tagName="p"     
                                                placeholder="Write your paragraph here"
                                                value={attributes.text}
                                                onChange={(newtext) => setAttributes({ text: newtext })}
                                            />
                                        )}
                                    </div>
                                    <InnerBlocks 
                                        template={[
                                            ['spice-blocks/spice-button', {
                                                title : 'Read More',
                                                titleColor : '#ffffff',
                                                bgColor : '#2c7bfe',
                                                border: {
                                                    color: '#ffffff',
                                                    style: 'solid',
                                                    width: '1px', 
                                                },
                                                bordertopradius : 30 + 'px',
                                                borderrightradius : 30 + 'px',
                                                borderbottomradius : 30 + 'px',
                                                borderleftradius : 30 + 'px',
                                                titlefontSize : 16 + 'px',
                                                TitleLineHeight : 26 ,
                                                fontfamily : 'Mulish',
                                                textAlignment : 'center',
                                            }]
                                        ]}
                                    allowedBlocks={ false } />
                                </div>
                            </div>
                        </Button>
                    }
                />
            )}            
        </Fragment>
    );
}

    registerBlockType('spice-blocks/spice-service-box',{
        title:__('Services Box','spice-blocks'),
        category: 'spice-blocks',
        icon:<svg xmlns="http://www.w3.org/2000/svg"  version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512"><g><g><path fill="#09A223" d="M476.776,100.649h-27.969c-1.874-7.98-5.022-15.473-9.233-22.244l19.791-19.791c6.665-6.665,6.665-17.471,0-24.136    c-6.664-6.665-17.471-6.665-24.136,0l-19.793,19.789c-6.772-4.211-14.263-7.359-22.245-9.233V17.067    C393.191,7.641,385.55,0,376.124,0c-9.425,0-17.067,7.641-17.067,17.067v27.97c-7.98,1.874-15.473,5.022-22.244,9.233    l-19.791-19.791c-6.664-6.665-17.471-6.665-24.136,0c-6.665,6.665-6.665,17.471,0,24.136l19.791,19.791    c-4.211,6.772-7.359,14.263-9.233,22.244h-27.969c-9.425,0-17.067,7.641-17.067,17.067s7.641,17.065,17.067,17.065h27.969    c1.874,7.98,5.022,15.473,9.233,22.245l-19.791,19.79c-6.665,6.664-6.665,17.471,0,24.136c6.664,6.665,17.469,6.665,24.136,0    l19.792-19.79c6.772,4.211,14.263,7.359,22.244,9.233v27.97c0,9.425,7.641,17.067,17.067,17.067s17.067-7.641,17.067-17.067    v-27.97c7.98-1.874,15.473-5.022,22.245-9.233l19.792,19.792c6.664,6.664,17.471,6.665,24.136,0s6.665-17.471,0-24.136    l-19.791-19.791c4.211-6.772,7.359-14.263,9.233-22.245h27.969c9.425,0,17.067-7.641,17.067-17.067    S486.201,100.649,476.776,100.649z M376.124,135.497c-9.804,0-17.781-7.977-17.781-17.781c0-9.805,7.977-17.781,17.781-17.781    c9.805,0,17.782,7.977,17.782,17.781C393.907,127.521,385.93,135.497,376.124,135.497z"/></g></g><g><g><path fill="#09A223" d="M476.773,377.219h-27.969c-1.874-7.98-5.022-15.473-9.233-22.245l19.791-19.791c6.665-6.664,6.665-17.471,0-24.136    c-6.664-6.664-17.471-6.665-24.136,0l-19.792,19.792c-6.772-4.211-14.263-7.359-22.245-9.233v-27.97    c0-9.425-7.641-17.067-17.067-17.067s-17.067,7.641-17.067,17.067v27.97c-7.98,1.874-15.471,5.022-22.244,9.233l-19.792-19.791    c-6.664-6.664-17.471-6.665-24.136,0c-6.665,6.665-6.665,17.471,0,24.136l19.79,19.791c-4.211,6.772-7.359,14.263-9.233,22.245    h-27.969c-9.425,0-17.067,7.641-17.067,17.067s7.641,17.067,17.067,17.067h27.969c1.874,7.98,5.022,15.473,9.233,22.244    l-19.79,19.791c-6.665,6.665-6.665,17.471,0,24.136c6.664,6.665,17.471,6.665,24.136,0l19.791-19.791    c6.771,4.211,14.263,7.359,22.244,9.233v27.968c0,9.425,7.641,17.067,17.067,17.067s17.067-7.641,17.067-17.067v-27.969    c7.98-1.874,15.473-5.022,22.245-9.233l19.792,19.791c6.664,6.665,17.471,6.666,24.136,0c6.665-6.665,6.665-17.471,0-24.136    l-19.791-19.79c4.211-6.772,7.359-14.263,9.233-22.244h27.969c9.425,0,17.067-7.641,17.067-17.067    S486.199,377.219,476.773,377.219z M376.124,412.066c-9.804,0-17.781-7.977-17.781-17.781c0-9.804,7.977-17.781,17.781-17.781    c9.805,0,17.782,7.977,17.782,17.781C393.907,404.09,385.93,412.066,376.124,412.066z"/></g></g><g><g><path fill="#09A223" d="M278.901,238.932h-36.773c-2.171-10.907-6.443-21.472-12.82-31.043l25.975-25.975c6.665-6.665,6.665-17.471,0-24.136    c-6.664-6.665-17.471-6.665-24.136,0l-25.976,25.975c-9.571-6.377-20.136-10.65-31.043-12.82V134.16    c0-9.425-7.641-17.067-17.067-17.067c-9.425,0-17.067,7.641-17.067,17.067v36.773c-10.907,2.171-21.472,6.443-31.043,12.82    l-25.975-25.975c-6.664-6.665-17.471-6.665-24.136,0s-6.665,17.471,0,24.136l25.975,25.975    c-6.377,9.571-10.651,20.136-12.822,31.043H35.224c-9.425,0-17.067,7.641-17.067,17.067s7.641,17.067,17.067,17.067h36.772    c2.171,10.907,6.443,21.472,12.822,31.043l-25.975,25.975c-6.665,6.665-6.665,17.471,0,24.136c6.664,6.665,17.471,6.666,24.136,0    l25.975-25.975c9.571,6.377,20.136,10.65,31.043,12.82v36.773c0,9.425,7.641,17.067,17.067,17.067s17.067-7.641,17.067-17.067    v-36.773c10.907-2.171,21.472-6.443,31.043-12.82l25.975,25.975c6.664,6.665,17.471,6.666,24.136,0    c6.665-6.664,6.665-17.469,0-24.135l-25.977-25.977c6.377-9.571,10.65-20.135,12.82-31.043h36.773    c9.425,0,17.067-7.641,17.067-17.067S288.327,238.932,278.901,238.932z M178.211,277.15    c-11.614,11.614-30.663,11.634-42.298-0.001c-11.614-11.614-11.635-30.662,0.001-42.298c11.616-11.616,30.664-11.634,42.299,0    C189.874,246.512,189.874,265.488,178.211,277.15z"/></g></g></svg>,
        example: {
            'attributes' : {
                'mode' : 'preview',
            }
        },
        keywords:['Spice Service','Service','Spice'],
        supports: {
        html: false,
        anchor: true,
        },
        attributes: {
            uniqueid:{
                type:'string'
            },
            imageUrl: {
                type: 'string',
                source:'attribute',
                attribute:'src',
                selector: 'img',
              },
              imageID:{
                  type:'number',
              },
              imageAlt:{
                type: 'string',
                source:'attribute',
                attribute:'alt',
                selector: 'img',
              },
            heading: {
                type: 'string',
                default:'Lorem ipsum',
            },
            text: {
                type: 'string',
                default:'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium',
            },
            textAlignment: {
                type: 'string',
                default:'center',
            },
            contentColor:{
                type:'string'
            },
            iconColor: {
                type: 'string',
                default:'#2c7bfe'

            },
            titleColor: {
                type: 'string',
                default:'#000000'
            },
            titlehColor:{
                type:'string',
                default:'#ffffff'
            },
            texthColor:{
                type:'string',
                default:'#ffffff'
            },
            textColor: {
                type: 'string',
                default:'#000000'
            },
            bgColor: {
                type: 'string',
            },
            bghColor:{
                type:'string',
                default:'#2c7bfe'
            },
            iconhColor:{
                type:'string',
                default:'#ffffff'
            },
            iconhbg:{
                type:'string',
            },
            iconv:{
                type:'string',
                default:'fa-solid fa-building fa-2x',
            },
            margins: {
                default: {
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px',
                }
            },
            paddings: {
                default: {
                    top: '20px',
                    left: '20px',
                    right: '20px',
                    bottom: '55px'
                }
            },
            iconPadding: {
                default: {
                    top: '0px',
                    left: '0px',
                    right: '0px',
                    bottom: '0px'
                }
            },
            titlePadding: {
                default: {
                    top: '8px',
                    left: '0px',
                    right: '0px',
                    bottom: '16px'
                }
            },
            textPadding: {
                default: {
                    top: '0px',
                    left: '0px',
                    right: '0px',
                    bottom: '30px'
                }
            },
            iconLineHeight:{
                type:'number',
                default:70
            },
            titleLineHeight:{
                type:'number',
                default:32
            },
            contentLineHeight:{
                type:'number',
                default:26
            },
            iconFontWeight:{
                type:'string',
                default:700
            },
            titleFontWeight:{
                type:'string',
                default:800
            },
            contentFontWeight:{
                type:'string',
                default:400
            },
            alignment:{
                type:'string',
                default:'center'
            },
            titlefontSize:{
                type:'string',
                default:'22px'
            },
            contentfontSize:{
                type:'string',
                default:'16px'
            },
            fontfamily:{
                type:'string',
                default:'Mulish'
            },
            contentfontfamily:{
                type:'string',
                default:'Mulish'
            },
            titleTransform:{
                type:'string'
            },
            textTransform:{
                type:'string'
            },
            titleDecoration:{
                type:'string'
            },
            textDecoration:{
                type:'string'
            },
            titleLetterSpacing:{
                type:'number'
            },
            textLetterSpacing:{
                type:'number'
            },
            iconWidth: {
                type: 'number',
                default:32
            },
            hshadow: {
                type: 'number',
                default: 0
            },
            vshadow: {
                type: 'number',
                default: 0
            },
            blurshadow: {
                type: 'number',
                default: 0
            },
            shadowColor:{
                type:'string',
                default:'#616161'
            },
            hidedesktop:{
                type: 'boolean',
                default: true
            },
            hidetablet:{
                type: 'boolean',
                default: true
            },
            hidemobile:{
                type: 'boolean',
                default: true
            },
            animation:{
                type:'string',
                default:'None'
            },
            durations:{
                type:'string',
                default:' '
            },
            delay:{
                type:'string',
            },
            hideDisplay:{
                type:'boolean',
                default: true
            },
            hideTitle:{
                type:'boolean',
                default: true
            },
            hideContent:{
                type:'boolean',
                default: true
            },
            bordertopradius:{
                type: 'string',
                default: '0px'
            },
            borderrightradius:{
                type: 'string',
                default: '0px'
            },
            borderbottomradius:{
                type: 'string',
                default: '0px'
            },
            borderleftradius:{
                type: 'string',
                default: '0px'
            },
            border:{
                type: 'object',
                default: {
                    color: '',
                    style: '',
                    width: '',        
                },
            },
            borderStyle:{
                type:'boolean',
                default:true
            },
            imgWidth:{
                type:'number'
            },
            imgHeight:{
                type:'number'
            },
            imgMargin:{
                default: {
                    top: '0px',
                    left: 'auto',
                    right: 'auto',
                    bottom: '15px'
                }
            },
            imgBorder:{
                type: 'object',
                default: {
                    color: '#ffffff',
                    style: 'solid',
                    width: '5px',        
                },
            },
            imgtopRadius:{
                type:'string',
                default: '50px'
            },
            imgleftRadius:{
                type:'string',
                default:'50px'
            },
            imgRightRadius:{
                type:'string',
                default:'50px'
            },
            imgBottomRadius:{
                type:'string',
                default:'50px'
            },
            imghshadow: {
                type: 'number',
                default: 0
            },
            imgvshadow: {
                type: 'number',
                default: 0
            },
            imgblurshadow: {
                type: 'number',
                default: 0
            },
            spreadRadius:{
                type:'number',
                default: 3
            },
            imgshadowColor:{
                type:'string',
                default:'#2196f3'
            },
            displayType:{
                type:'string',
                default:'icon'
            },
            addid:{
                type:'string',
            },
            addclass:{
                type:'string',
            },
            customcss:{
                type:'string',
            }
        },
        edit: ServiceBlock,
        save: (props) => {

        const { bghColor, bgColor , iconFontWeight, iconLineHeight, titlefontSize, titleLineHeight, titleFontWeight, contentfontSize, contentFontWeight,contentLineHeight, iconColor, titleColor, textColor, margins, paddings, iconhColor, uniqueid, textAlignment, titlehColor, texthColor, iconv, fontfamily,contentfontfamily, iconPadding, titlePadding, textPadding, titleDecoration, titleTransform, titleLetterSpacing, textTransform, textDecoration, textLetterSpacing, iconWidth, hshadow, vshadow, blurshadow,shadowColor, animation, delay, durations, hidedesktop, hidetablet, hidemobile, hideDisplay, hideTitle, hideContent, border, borderbottomradius, borderleftradius, borderrightradius, bordertopradius, borderStyle, imageUrl, imgBorder, imgBottomRadius, imgHeight, imgMargin, imgRightRadius, imgleftRadius, imgtopRadius, imgWidth, imghshadow, imgvshadow, imgblurshadow, imgshadowColor, displayType, spreadRadius, addclass, addid, customcss } = props.attributes;

        const { attributes } = props;


        const animationclass='wow animated '+attributes.durations+' '+attributes.animation;
        const displaydesktop=(hidedesktop != true) ? 'hide-desktop' : '';
        const displaytablet=(hidetablet != true) ? 'hide-tablet' : '';
        const displaymobile=(hidemobile != true) ? 'hide-mobile' : '';
        const displayclass=displaydesktop+' '+displaytablet+' '+displaymobile;
        const alignmentClass = (attributes.textAlignment != null) ? 'has-text-align-' + attributes.textAlignment : 'has-text-align-center';
        const blocktop=(border.top != undefined) ? `${border.top.width} ${border.top.style} ${border.top.color}` : null;
        const blockright=(border.right != undefined) ? `${border.right.width} ${border.right.style} ${border.right.color}` : null;
        const blockbottom=(border.bottom != undefined) ? `${border.bottom.width} ${border.bottom.style} ${border.bottom.color}` : null;
        const blockleft=(border.left != undefined) ? `${border.left.width} ${border.left.style} ${border.left.color}` : null;
        const serviceImage = plugin.pluginpath + 'assets/images/user2.jpg';
        const hideCorner =(borderStyle != true) ? 'hide-corner' : '';
        const hideStyle = hideCorner;
        const serviceBox = 'service-box';        
        const serviceValue= ( imageUrl !=null )? imageUrl:serviceImage;
        const iconbgimage=(1.5625*iconWidth);
        const bordertop=(imgBorder.top != undefined) ? `${imgBorder.top.width} ${imgBorder.top.style} ${imgBorder.top.color}` : null;
        const borderright=(imgBorder.right != undefined) ? `${imgBorder.right.width} ${imgBorder.right.style} ${imgBorder.right.color}` : null;
        const borderbottom=(imgBorder.bottom != undefined) ? `${imgBorder.bottom.width} ${imgBorder.bottom.style} ${imgBorder.bottom.color}` : null;
        const borderleft=(imgBorder.left != undefined) ? `${imgBorder.left.width} ${imgBorder.left.style} ${imgBorder.left.color}` : null;
      
        return (
            <>
            <script> 
                    var fontfamily2=`{fontfamily}`;
                    var url2 = 'https://fonts.googleapis.com/css2?family='+fontfamily2+':wght@100;200;300;400;500;600;700;800;900&display=swap';
                    var link2 = document.createElement('link');
                    link2.href = url2;
                    link2.rel = "stylesheet";
                    link2.type =  "text/css";             
                    document.head.appendChild(link2);

                    var contentfontfamily2=`{contentfontfamily}`;
                    var contentfontfamilyurl2 = 'https://fonts.googleapis.com/css2?family='+contentfontfamily2+':wght@100;200;300;400;500;600;700;800;900&display=swap';
                    var contentfontfamilylink2 = document.createElement('link');
                    contentfontfamilylink2.href = contentfontfamilyurl2;
                    contentfontfamilylink2.rel = "stylesheet";
                    contentfontfamilylink2.type =  "text/css";            
                    document.head.appendChild(contentfontfamilylink2);
            </script>
            <style dangerouslySetInnerHTML={{
              __html: [
                 `.service-box#${uniqueid}{
                    background-color : ${bgColor};
                    margin: ${margins.top} ${margins.right} ${margins.bottom} ${margins.left};
                    padding: ${paddings.top} ${paddings.right} ${paddings.bottom} ${paddings.left};
                    box-shadow: ${hshadow}px ${vshadow}px ${blurshadow}px ${shadowColor};
                    border: ${border.width} ${border.style} ${border.color};
                    border-top:${blocktop};
                    border-right:${blockright};
                    border-bottom:${blockbottom};
                    border-left:${blockleft};
                    border-radius: ${bordertopradius} ${borderrightradius} ${borderbottomradius} ${borderleftradius};
                 }
                 .hide-corner#${uniqueid}:before{
                    display: none;
                 }
                 .hide-corner#${uniqueid}:after{
                    display: none;
                 }
                 .service-box#${uniqueid}:before{
                    border-left: 2px solid ${bghColor};
                    border-top: 2px solid ${bghColor};
                 }
                 .service-box#${uniqueid} .icon:before{
                    width:${iconbgimage}px;
                    height:${iconbgimage}px;
                 }
                 .service-box#${uniqueid}:after{
                    border-right: 2px solid ${bghColor};
                    border-bottom: 2px solid ${bghColor};
                 }
                 .service-box#${uniqueid} .icon i{
                    color: ${iconColor}; 
                    font-size: ${iconWidth + 'px'};
                    font-weight: ${iconFontWeight};
                    line-height: ${iconLineHeight}px;
                    padding: ${iconPadding.top} ${iconPadding.right} ${iconPadding.bottom} ${iconPadding.left};
                 }
                 .service-box#${uniqueid} .col-text h4{
                    color: ${titleColor};
                    font-size: ${titlefontSize};
                    font-weight: ${titleFontWeight};
                    font-family: ${fontfamily};
                    padding: ${titlePadding.top} ${titlePadding.right} ${titlePadding.bottom} ${titlePadding.left};
                    text-transform: ${titleTransform};
                    text-decoration: ${titleDecoration};
                    line-height: ${titleLineHeight}px;
                    letter-spacing: ${titleLetterSpacing + 'px'};
                 }
                 .service-box#${uniqueid} .col-text p{
                    color: ${textColor};
                    font-size: ${contentfontSize};
                    font-weight: ${contentFontWeight};
                    font-family: ${contentfontfamily};
                    padding: ${textPadding.top} ${textPadding.right} ${textPadding.bottom} ${textPadding.left};
                    text-transform: ${textTransform};
                    text-decoration: ${textDecoration};
                    line-height: ${contentLineHeight}px;
                    letter-spacing: ${textLetterSpacing + 'px'};
                 }
                    .service-box#${uniqueid}:hover{
                        background-color: ${bghColor};                    
                    }
                    .service-box#${uniqueid}:hover .icon i{
                        color: ${iconhColor} ;
                    }
                    .service-box#${uniqueid}:hover .col-text h4{
                        color: ${titlehColor} ;
                    }
                    .service-box#${uniqueid}:hover .col-text p{
                        color: ${texthColor} ;
                    }
                    .service-box#${uniqueid} .service-box-avatar{
                         margin: ${imgMargin.top} ${imgMargin.right ? imgMargin.right: 'auto'} ${imgMargin.bottom} ${imgMargin.left ? imgMargin.left: 'auto'};
                        width: ${imgWidth + 'px'};
                        height: auto;
                      }
                    .service-box#${uniqueid} .service-box-avatar img{
                        border: ${imgBorder.width} ${imgBorder.style} ${imgBorder.color};
                        border-top:${bordertop};
                        border-right:${borderright};
                        border-bottom:${borderbottom};
                        border-left:${borderleft};
                        border-radius: ${imgtopRadius} ${imgRightRadius} ${imgBottomRadius} ${imgleftRadius};
                        box-shadow: ${imgshadowColor} ${imghshadow}px ${imgvshadow}px ${imgblurshadow}px ${spreadRadius}px ;
                    }
                    .${uniqueid}.has-text-align-right .service-box#${uniqueid}  figure.service-box-avatar{margin-right: 0;}
                    .${uniqueid}.has-text-align-left .service-box#${uniqueid} figure.service-box-avatar{margin-left: 0;}
                    .${uniqueid}.has-text-align-right figure.service-box-avatar{margin-right: 0;}
                    .${uniqueid}.has-text-align-left figure.service-box-avatar{margin-left: 0;}
                ${customcss}`           
                ].join('\n')
              }}>
            </style>
                <div className={`${animationclass} ${displayclass} ${alignmentClass} ${props.attributes.className} ${uniqueid} ${addclass}`} style={{ 
                    animationDelay: delay+ 'ms',        
                }} id={`${addid}`}>
                    <div className={`${serviceBox} ${hideStyle}`} id={uniqueid}>
                        {hideDisplay && (
                            <Fragment>
                                {displayType == 'icon' && (
                                    <div className='icon'>
                                        <i className={iconv} ></i>
                                    </div>
                                )}
                                {displayType == 'image' && (
                                    <figure className='service-box-avatar' onClick={open}>
                                        <img src={serviceValue} 
                                            alt={props.attributes.imageAlt}/>
                                    </figure>  
                                )}
                            </Fragment>
                        )}
                        <div class="col-text">
                            {hideTitle && (
                                <RichText.Content 
                                    tagName="h4"    
                                    value={attributes.heading}
                                />
                            )}
                            {hideContent && (
                                <RichText.Content 
                                    tagName="p"
                                    value={attributes.text}
                                />
                            )}
                        </div>
                        <InnerBlocks.Content />                                 
                    </div>
                </div>
            </>         
        )
        }
    });